import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=6bf8aa76&scoped=true"
import script from "./depositList.vue?vue&type=script&lang=ts"
export * from "./depositList.vue?vue&type=script&lang=ts"
import style0 from "./depositList.vue?vue&type=style&index=0&id=6bf8aa76&prod&lang=scss"
import style1 from "./depositList.vue?vue&type=style&index=1&id=6bf8aa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8aa76",
  null
  
)

export default component.exports